module.exports = __webpack_public_path__ + "assets/img/cb004450d341be1d5477e3b53a961b93.png";